module.exports = __webpack_public_path__ + "img/emblem.bfa3e8f6.png";